export default __webpack_public_path__ + "static/media/exam-ecv-logo.0d22bb3c.svg";